import { useRef, useCallback } from "react";
import { View, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Button } from "@/components/ui/Button";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { useToolTip } from "@/hooks/useToolTip";
import useAuth from "@/hooks/useAuth";

export function HeaderTooltipButton({
  icon,
  tooltip,
  onPress,
  style,
}: {
  icon: keyof typeof MaterialCommunityIcons.glyphMap;
  tooltip: string;
  onPress: () => void;
  style?: any;
}) {
  const { colors } = useTheme();
  const { session } = useAuth();
  const toolTip = useToolTip();
  const ref = useRef<View>(null);
  const isHovering = useRef(false);

  const handlePointerEnter = useCallback(() => {
    isHovering.current = true;
    toolTip.setToolTipContent(
      <View
        style={{
          backgroundColor: colors.background,
          paddingHorizontal: 8,
          paddingVertical: 4,
          borderRadius: 8,
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: colors.border,
        }}
      >
        <ThemedText style={{ fontSize: 12 }}>{tooltip}</ThemedText>
      </View>,
    );
    ref.current?.measureInWindow((x, y, w, h) => {
      if (!isHovering.current) return;
      const xOffset = session ? -50 : -80;
      toolTip.setLocation({ x: x + (w || 0) / 2 + xOffset, y: y + (h || 0) + 4, width: 100, height: 30 } as any);
      toolTip.setVisible(true);
    });
  }, [tooltip, colors.background, colors.border, toolTip, session]);

  const handlePointerLeave = useCallback(() => {
    isHovering.current = false;
    toolTip.setVisible(false);
  }, [toolTip]);

  return (
    <View ref={ref} onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave}>
      <Button
        icon={icon}
        onPress={() => {
          toolTip.setVisible(false);
          onPress();
        }}
        style={style}
        iconSize={22}
      />
    </View>
  );
}
